module.exports = __webpack_public_path__ + "media/images/browser-e6f7b406ce76f61e1b1a3b9fcc78f39b.png";